import { FC, useMemo } from "react";
import { useAppSelector } from "../store";

import { VviinnForms } from "../forms";

import { useParams } from "react-router";
import { pageError } from "./error";
import { useNotifications } from "../app/useNotifications";

export const Report: FC = () => {
  const { reportId } = useParams();
  const { notify } = useNotifications();
  const company = useAppSelector((state) => state.company?.company);
  const relevantReport = useMemo(() => {
    return reportId
      ? company?.reports?.items?.all?.find(({ action }) =>
          action?.navigateUrl?.endsWith(reportId),
        )
      : undefined;
  }, [reportId]);

  return relevantReport ? (
    <VviinnForms
      formType="report"
      id={reportId}
      actionId={relevantReport.action.id}
      requestType={relevantReport.action.requestType}
      onSuccess={() =>
        notify("Success", "Your request will be fulfilled soon.")
      }
    />
  ) : (
    pageError("404")
  );
};
